goog.provide('el8.apphome.reqAct.actions');

goog.require('el8.appchart.letters.dialog.resendLetterWithNewUnreadAlertNotification');
goog.require('el8.appchart.letters.dialog.updateUnreadAlertNotification');
goog.require('el8.app.shared.dialog.viewInlinePdf');
goog.require('el8.apphome.reqAct.reqActPatients');
goog.require('el8.appshared.dialog.reassignPatient');
goog.require('el8.appshared.dialog.reassignReviewUser');
goog.require('el8.appshared.dialog.refileRxRefill');
goog.require('el8.appshared.message');
goog.require('el8.appshared.signOff');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.letterReceipts');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.patients');
goog.require('el8.service.urls');
goog.require('el8.shared.commentReplyForm');
goog.require('el8.util.consts');
goog.require('el8.util.feed');

el8.apphome.reqAct.actions.buttons = function(item) {

    var mClass = item.getModelClass();
    var buttonsInfo = [];

    switch(mClass) {

        case 'RxRefillRequest':
            buttonsInfo.push({
                name: 'Find Patient',
                htmlClass: 'rx-refill-file-trigger'
            });
            buttonsInfo.push({
                name: 'Deny',
                htmlClass: 'rx-refill-deny-no-pt-trigger'
            });
            break;

        case 'MessageThread':
            if (item.isSignedOff()) {
                if (item.isAcknowledgeableBy(el8.data.currUser.getId())) {
                    buttonsInfo.push({
                        name: 'Acknowledge',
                        htmlClass: 'chartAcknowledgeTrigger feedSignoff',
                        isRealButton: true
                    });
                }
                else if (item.isAcknowledgeableByAnyone()
                            && el8.data.currUser.isElationStaff()) {
                    buttonsInfo.push({
                        name: 'Acknowledge For All',
                        htmlClass: 'chartAcknowledgeForAllTrigger feedSignoff',
                        isRealButton: true
                    });
                }

            } else {
                // If not signed off...
                if (item.canUserSign()) {
                    buttonsInfo.push({
                        name: 'Sign Off',
                        htmlClass: 'chartSignOffTrigger feedSignoff',
                        isRealButton: true
                    });
                }
                else if (item.isStaffOnly()) {
                  var newOfficeMessages = el8Globals.FEATURES.NewOfficeMessages;
                  buttonsInfo.push({
                      name: newOfficeMessages ? 'Mark Complete' : "Acknowledge for Group",
                      htmlClass: 'chartSignOffTrigger feedSignoff',
                      isRealButton: true
                  });
                }
            }
            break;

        case 'IncomingEmail':
            if (item.getFromUserId() === el8.data.currUser.getId()) {
                buttonsInfo.push({
                    name: 'File to Chart',
                    htmlClass: 'assign-email-trigger'
                });
                buttonsInfo.push({
                    name: 'Remove',
                    htmlClass: 'remove-email-trigger'
                });
            }
            break;

        case 'NonvisitNote':
            // only nonvisitnote we show in the practice home required action is for
            // converted direct message, and we only let user open up the pt chart from here
            // to then be signed off, we don't let them sign off directly
            buttonsInfo.push({
                name: 'View Chart',
                htmlClass: 'view-chart-nonvisit-note-trigger'
            });
            break;

        case 'IncomingDirectMessage':
            // no action here for direct messages, user must open the chart and
            // review the item there in required action queue and sign off there
            buttonsInfo.push({
                name: 'View Chart',
                htmlClass: 'view-chart-direct-message-trigger'
            });
            break;

        case 'Letter':
            if (item.getFaxStatus() === 'failed') {
                // Acknowledge for failed faxes
                buttonsInfo.push({
                    name: 'Re-fax',
                    htmlClass: 'resend-failed-fax-trigger',
                    isRealButton: true
                });
            } else if (item.getNewCommentCount()) {
                // Acknowledge for patient letters with new comments
                buttonsInfo.push({
                    name: 'Acknowledge',
                    htmlClass: 'acknowledge-comments-trigger',
                    isRealButton: true
                });
            }
            break;

        case 'LetterReceipt':
            if (!item.isSignedOff()) {
                if (!el8Globals.PASSPORT_EMR) {

                    buttonsInfo.push({
                        name: 'Write Message',
                        htmlClass: 'write-message-pt-letter-trigger',
                        isRealButton: true
                    });

                    buttonsInfo.push({
                        name: 'Sign Off',
                        htmlClass: 'sign-letter-receipt',
                        isRealButton: true
                    });

                }
            } else if (item.getNewCommentCount()) {
                // Acknowledge for letters from another practice with new comments
                buttonsInfo.push({
                    name: 'Acknowledge',
                    htmlClass: 'acknowledge-comments-trigger',
                    isRealButton: true
                });
            }
            break;
        case 'UnreadLetterNotification':
            // unread and has active alert
            if (item.getLetter().getDeliveryMethod() !== 'emr') {
                buttonsInfo.push({
                    name: 'Resend',
                    htmlClass: 'resend-unread-letter-trigger',
                    isRealButton: true
                });
            }

            buttonsInfo.push({
                name: 'Acknowledge',
                htmlClass: 'acknowledge-unread-letter-trigger',
                isRealButton: true
            });
            buttonsInfo.push({
                name: 'Write Message',
                htmlClass: 'write-message-unread-letter-trigger',
                isRealButton: true
            });
            buttonsInfo.push({
                name: 'Notify me again later',
                htmlClass: 'notify-again-unread-letter-trigger',
                isRealButton: true
            });
            break;

        case 'DocumentReminderNotification':
            buttonsInfo.push({
                name: 'Fulfilled',
                htmlClass: 'reminder-notification-fulfill-trigger',
                isRealButton: true
            });
            buttonsInfo.push({
                name: 'Cancel Order',
                htmlClass: 'reminder-notification-cancel-trigger',
                isRealButton: true
            });
            buttonsInfo.push({
                name: 'Write Message',
                htmlClass: 'reminder-notification-write-message-trigger',
                isRealButton: true
            });
            buttonsInfo.push({
                name: 'Remind Later',
                htmlClass: 'reminder-notification-remind-later-trigger',
                isRealButton: true
            });
            break;

        case 'PatientCollaboratorNotification':
            if (item.getEventType() === 'plr4all_invited') {
                buttonsInfo.push({
                    name: 'View Chart',
                    htmlClass: 'view-chart-plr-notification-trigger',
                    isRealButton: true
                });
            } else {
                buttonsInfo.push({
                    name: 'Acknowledge',
                    htmlClass: 'acknowledge-plr-notification',
                    isRealButton: true
                });
            }
            break;
        case 'MedOrder':
            break;
        case 'ReqActPatient':
            // NOTE: if ReqActPatient is showing in the reports feed,
            // then shows a "Re-assign" button. This logic is in the template right now.
            break;
        default:
            break;

    }

    return buttonsInfo;

};


el8.apphome.reqAct.actions.clickMap = {
    // DocumentNotification triggers
    '.reminder-notification-fulfill-trigger': function($target, feed) {
        var container = $target.closest('.document-reminder-notification-item');
        var notificationId = container.data('id');
        var patientId = container.data('patient-id');

        // Open the attachment dialog, passing in patientId
        el8.app.shared.dialog.reportAttachments.show({
            callbackFn: function (attachmentItems) {
                if (attachmentItems.length) { // just one or none
                    var attachment = attachmentItems[0];
                    var notification = el8.ptdata.documentReminderNotifications.getById(notificationId);
                    notification.fulfill({
                        resolvingDocumentId: attachment.getId(),
                        successCb: function () {
                            feed.updatePatientAfterResponse(patientId, notificationId);
                        },
                        noRefresh: true
                    });
                }
            },
            patientId: patientId,
            noRefresh: true
        });
    },
    '.reminder-notification-cancel-trigger': function($target, feed) {
        var container = $target.closest('.document-reminder-notification-item');
        var id = container.data('id')*1;
        var patientId = container.data('patient-id')*1;
        var notification = el8.ptdata.documentReminderNotifications.getById(id);
        notification.cancel({
            successCb: function() {
                feed.updatePatientAfterResponse(patientId, id);
            },
            noRefresh: true
        });
    },
    '.reminder-notification-remind-later-trigger': function($target, feed) {
        var container = $target.closest('.document-reminder-notification-item');
        var id = container.data('id')*1;
        var patientId = container.data('patient-id')*1;
        var notification = el8.ptdata.documentReminderNotifications.getById(id);
        notification.remindLater({
            successCb: function() {
                feed.updatePatientAfterResponse(patientId, id);
            },
            noRefresh: true,
            patientId: patientId
        });
    },

    '.reminder-notification-write-message-trigger': function($target, feed) {
        var container = $target.closest('.document-reminder-notification-item');
        var notification = el8.ptdata.fetch({fetchId: container.data('id')});
        el8.appshared.message.prePopulateNewMessage({
            toDocId: notification.getDocumentId(),
            rePatientId: container.data('patient-id')
        });
    },

    // Other triggers
    '.launch-patient-trigger': function($target) {
        var pid = $target.data('id');
        var url = el8.service.urls.get('patientChart', [pid, true, el8Globals['ONBOARDING']]);
        window.open(url);
    },
    '.view-inline-pdf': function($target) {
        var id = $target.data('id');
        var container = $target.closest('.letter-item, .letter-receipt-item, .feed-item');
        el8.app.shared.dialog.viewInlinePdf.show({
            patientId: container.data('patient-id'),
            docFileId: id
        });
    },
    '.rx-refill-file-trigger': function($target, feed) {
        var fid = $target.attr('_fid');
        var itemId = el8.util.feed.fromFeedItemId(fid)['id']*1;
        feed.highlight(itemId).freeze();
        el8.appshared.dialog.refileRxRefill.show(itemId, function() {
            // Remove the item from the feed
            feed.unfreeze();
            feed.remove(itemId, el8.util.consts.DEFAULT_DURATION);
        });
    },
    '.rx-refill-deny-no-pt-trigger': function($target, feed) {
        var fid = $target.attr('_fid');
        var itemId = el8.util.feed.fromFeedItemId(fid)['id']*1;
        feed.highlight(itemId).freeze();
        $.el8_ajax({
            url: '/rxrefill/'+ itemId +'/deny/',
            type: "POST",
            data: null,
            success: function(data) {
                // Remove the item from the feed
                feed.unfreeze();
                feed.remove(itemId, el8.util.consts.DEFAULT_DURATION);
            }
        });
    },
    '.assign-email-trigger': function($target, feed) {
        var fid = $target.attr('_fid');
        var itemId = el8.util.feed.fromFeedItemId(fid)['id']*1;
        feed.highlight(itemId).freeze();
        el8.appshared.dialog.reassignPatient.show({
            docId: itemId,
            successCb: function() {
                // Remove the item from the feed
                feed.unfreeze();
                feed.remove(itemId, el8.util.consts.DEFAULT_DURATION);
            },
            cancelCb: function() {
                feed.unhighlight(itemId).unfreeze();
            }
        });
    },
    '.remove-email-trigger': function($target, feed) {
        var fid = $target.attr('_fid');
        var itemId = el8.util.feed.fromFeedItemId(fid)['id']*1;
        feed.highlight(itemId).freeze();
        $.el8_ajax({
            type: 'DELETE',
            url: el8.service.urls.get('deleteEmail', [itemId]),
            success: function() {
                // Remove the item from the feed
                feed.unfreeze();
                feed.remove(itemId, el8.util.consts.DEFAULT_DURATION);
            },
            error: function() {
                feed.unhighlight(itemId).unfreeze();
            }
        });
    },
    '.view-chart-direct-message-trigger': function($target, feed) {
        var container = $target.closest('.direct-message-item');
        var patientId = container.data('patient-id')*1;
        var url = el8.service.urls.get('patientChart', [patientId, true, el8Globals['ONBOARDING']]);
        window.open(url);
    },
    '.view-chart-nonvisit-note-trigger': function($target, feed) {
        // refers to direct-message-item here since we're using directmessage template
        var container = $target.closest('.direct-message-item');
        var patientId = container.data('patient-id')*1;
        var url = el8.service.urls.get('patientChart', [patientId, true, el8Globals['ONBOARDING']]);
        window.open(url);
    },
    '.view-chart-plr-notification-trigger': function($target, feed) {
        var container = $target.closest('.plr-notification-item');
        var patientId = container.data('patient-id')*1;
        var url = el8.service.urls.get('patientChart', [patientId, true, el8Globals['ONBOARDING']]);
        window.open(url);
    },
    // currently unused
    '.signoff-direct-message-trigger': function($target, feed) {
        var container = $target.closest('.direct-message-item');
        var id = container.attr('_id')*1;
        var patientId = container.data('patient-id')*1;
        el8.ptdata.directMessages.getById(id).signOff({
            patientId: patientId,
            successCb: function() { feed.updatePatientAfterResponse(patientId, id); },
            errorCb: function() { feed.refresh(); }
        });
    },
    // currently unused
    '.remove-direct-message-trigger': function($target, feed) {
        var container = $target.closest('.direct-message-item');
        var id = container.attr('_id')*1;
        var patientId = container.data('patient-id')*1;

        el8.ptdata.directMessages.getById(id).deleteItem({
            patientId: patientId,
            successCb: function() { feed.updatePatientAfterResponse(patientId, id); },
            errorCb: function() { feed.refresh(); }
        });

    },
    '.resend-failed-fax-trigger': function($target, feed) {
        var container = $target.closest('.letter-item');
        var letterId = container.attr('_id')*1;
        var patientId = container.data('patient-id')*1;
        el8.ptdata.letters.getById(letterId).refaxLetter({
            successCb: function() {
                feed.updatePatientAfterResponse(patientId, letterId);
            }
        });
    },
    '.acknowledge-comments-trigger': function($target, feed) {
        var container = $target.closest('.letter-item, .letter-receipt-item');
        var docId = container.attr('_id')*1;
        var patientId = container.data('patient-id')*1;
        var item = (el8.model.idToModelClass(docId) === 'Letter') ?
            el8.ptdata.letters.getById(docId) : el8.ptdata.letterReceipts.getById(docId);
        item.dismissComments(function() {
            feed.updatePatientAfterResponse(patientId, docId);
        });
    },
    '.sign-letter-receipt': function($target, feed) {
        var container = $target.closest('.letter-receipt-item');
        var id = container.attr('_id')*1;
        var patientId = container.data('patient-id')*1;
        el8.ptdata.letterReceipts.getById(id).sign({
            $receiptElem: container,
            successCb: function() { feed.updatePatientAfterResponse(patientId, id); },
            errorCb: function() { feed.refresh(); }
        });
    },
    '.sign-file-letter-receipt': function($target, feed) {
        el8.uiwidget.alert('not yet implemented');
    },
    '.file-receipt-report': function($target, feed) {
        var container = $target.closest('.letter-receipt-item');
        var receiptId = container.attr('_id')*1;
        var attachmentId = $target.data('id');
        el8.ptdata.letterReceipts.getById(receiptId).fileReport(attachmentId, function(updated) {
            $('.attachment-section', container).replaceWith(
                el8.template.ptdata.letterReceipts.attachmentSection(updated.asSoyMap())
            );
        });
    },
    '.close-letter-comments-trigger': function($target, feed) {
        var container = $target.closest('.letter-item');
        var letterId = container.attr('_id')*1;
        var patientId = container.data('patient-id')*1;
        el8.ptdata.letters.getById(letterId).closeThread(function() {
            feed.updatePatientAfterResponse(patientId, letterId);
        });
    },
    '.write-message-trigger': function($target, feed) {
        var itemId = $target.data('id')*1;
        if (!itemId) {  // tolerate data id or _fid
            var fid = $target.attr('_fid');
            itemId = el8.util.feed.fromFeedItemId(fid)['id']*1;
        }
        var patientId = el8.ptdata.fetchById(itemId).getPatientId();
        el8.appshared.message.prePopulateNewMessage({
            toDocId: itemId,
            rePatientId: patientId
        });
    },
    '.write-message-unread-letter-trigger': function($target, feed) {
        var container = $target.closest('.unread-letter-notification-item');
        var itemId = container.attr('_id')*1;
        var item = el8.ptdata.fetch({fetchId: itemId});
        var patientId = container.data('patient-id')*1;
        el8.appshared.message.prePopulateNewMessage({
            toDocId: item.getLetter().getId(),
            rePatientId: patientId
        });
    },
    '.acknowledge-plr-notification': function($target, feed) {
        var container = $target.closest('.plr-notification-item');
        var notification = el8.ptdata.fetchById(container.data('id'));
        notification.acknowledge(function() {
            feed.updatePatientAfterResponse(notification.getPatientId(), notification.getId());
        });
    },
    '.acknowledge-unread-letter-trigger': function($target, feed) {
        var container = $target.closest('.unread-letter-notification-item');
        var itemId = container.attr('_id')*1;
        var item = el8.ptdata.fetch({fetchId: itemId});
        var patientId = container.data('patient-id')*1;
        item.acknowledgeAndSignOff({
            successCb: function() {
                feed.updatePatientAfterResponse(patientId, itemId);
            }
        });
    },
    '.resend-unread-letter-trigger': function($target, feed) {
        var container = $target.closest('.unread-letter-notification-item');
        var itemId = container.attr('_id')*1;
        var item = el8.ptdata.fetch({fetchId: itemId});
        var patientId = container.data('patient-id')*1;
        var opts = {
            successCb: function(updatedLetter) {
                feed.updatePatientAfterResponse(patientId, itemId);
            }
        };
        el8.appchart.letters.dialog.resendLetterWithNewUnreadAlertNotification.show(item, opts);
    },
    '.notify-again-unread-letter-trigger': function($target, feed) {
        var container = $target.closest('.unread-letter-notification-item');
        var itemId = container.attr('_id')*1;
        var item = el8.ptdata.fetch({fetchId: itemId});
        var patientId = container.data('patient-id')*1;
        var opts = {
            successCb: function(updatedNotification) {
                feed.updatePatientAfterResponse(patientId, itemId);
            }
        };
        el8.appchart.letters.dialog.updateUnreadAlertNotification.show(item, opts);
    },
    '.write-message-pt-letter-trigger': function($target, feed) {
        var container = $target.closest('.letter-receipt-item');
        var itemId = container.attr('_id')*1;
        var patientId = container.data('patient-id');
        el8.appshared.message.prePopulateNewMessage({
            toDocId: itemId,
            rePatientId: patientId
        });
    },
    '.comment-reply-trigger': function($target, feed) {
        var docId = $target.data('doc-id');
        var container = $target.closest('.letter-item, .letter-receipt-item');
        var patientId = container.data('patient-id')*1;
        feed.freeze();
        el8.shared.commentReplyForm.show({
            container: container,
            docId: docId,
            sendCallback: function(item) {
                if (item.is('Letter')) {
                    var patient = el8.ptdata.patients.getById(patientId);
                    var ptName = patient ? patient.getFullName() : 'patient';
                    el8.appservice.notifier.notify('Response sent to '+ptName+' - letter removed from Requiring Actions.');
                    feed.updatePatientAfterResponse(patientId, docId);

                } else if (item.is('LetterReceipt')) {
                    var senderName = item.getSenderName() || 'sender';
                    el8.appservice.notifier.notify('Response sent to '+senderName+'.');
                    if (item.isSignedOff()) {
                        feed.updatePatientAfterResponse(patientId, docId);
                    } else {
                        feed.updatePatientAfterResponse(patientId);
                    }
                }
            },
            cancelCallback: function() {
                feed.unfreeze();
            }
        });
    },
    '.reopen-comments-trigger': function($target, feed) {
        var letterId = $target.data('id')*1;
        var container = $target.closest('.letter-item');
        var patientId = container.data('patient-id')*1;
        el8.ptdata.letters.getById(letterId).reopenThread(function() {
            feed.updatePatientAfterResponse(patientId, letterId);
        });
    },
    '.sign-and-close-pt-comments-trigger': function($target, feed) {
        var container = $target.closest('.letter-receipt-item');
        var receiptId = $target.data('doc-id');
        var patientId = container.data('patient-id');

        el8.ptdata.letterReceipts.getById(receiptId).sign({
            $receiptElem: container,
            successCb: function() {
                el8.ptdata.letterReceipts.getById(receiptId).addComment({
                    closeThread: true,
                    successCb: function() { feed.updatePatientAfterResponse(patientId, receiptId); },
                    errorCb: function() { feed.refresh(); }
                });
            }
        });
    },

    // for signed pt-sent letter receipts
    '.close-pt-comments-trigger': function($target, feed) {
        var container = $target.closest('.letter-receipt-item');
        var receiptId = $target.data('doc-id');
        var patientId = container.data('patient-id');

        el8.ptdata.letterReceipts.getById(receiptId).addComment({
            closeThread: true,
            successCb: function() { feed.updatePatientAfterResponse(patientId, receiptId); },
            errorCb: function() { feed.refresh(); }
        });
    },

    /**
     * Message threads
     */
    '.chartAcknowledgeTrigger': function($target, feed) {
        var fid = $target.attr('_fid');
        var patientId = $target.closest('.message-wrapper').attr('data-patient-id')*1;
        var threadId = el8.util.feed.fromFeedItemId(fid)['id']*1;
        var thread = el8.ptdata.messageThreads.getById(threadId);
        el8.appshared.message.acknowledgeThread(thread, function() {
            feed.updatePatientAfterResponse(patientId, threadId);
        });
    },
    '.chartAcknowledgeForAllTrigger': function($target, feed) {
        var fid = $target.attr('_fid');
        var patientId = $target.closest('.message-wrapper').attr('data-patient-id')*1;
        var threadId = el8.util.feed.fromFeedItemId(fid)['id']*1;
        var thread = el8.ptdata.messageThreads.getById(threadId);
        el8.appshared.message.acknowledgeThreadForAll(thread, function() {
            feed.updatePatientAfterResponse(patientId, threadId);
        });
    },
    '.chartSignOffTrigger': function($target, feed) {
        var fid = $target.attr('_fid');
        var patientId = $target.closest('.message-wrapper').attr('data-patient-id')*1;
        var threadId = el8.util.feed.fromFeedItemId(fid)['id']*1;
        var thread = el8.ptdata.messageThreads.getById(threadId);
        if (thread.is('MessageThread') && !thread.hasAnyOneElseReplied()) {
            var str = el8.data.currUser.isPhysician() ? 'Confirm message sign off?' : 'Confirm filing this message into chart?';
            el8.uiwidget.confirm(str+' This action cannot be undone. Other recipients can still acknowledge this message.',
            function() {
                    el8.appshared.signOff(thread, function() {
                        feed.updatePatientAfterResponse(patientId, threadId);
                    });
                }
            );
        } else {
            el8.appshared.signOff(thread, function() {
                feed.updatePatientAfterResponse(patientId, threadId);
            });
        }
    },
    '.threadReplyTrigger': function($target, feed) {
        var fid = $target.attr('_fid');
        var container = $target.closest('.message-wrapper');
        var patientId = container.attr('data-patient-id')*1;
        var threadId = el8.util.feed.fromFeedItemId(fid)['id']*1;
        var thread = el8.ptdata.messageThreads.getById(threadId);
        feed.freeze();
        el8.appshared.message.showReplyMessageForm(thread, container, {
            callbackFn: function(_thread, data, noRemove) {
                feed.updatePatientAfterResponse(patientId, noRemove ? null : threadId);
            },
            closeFn: function() {
                feed.unfreeze();
            }
        });
    },

    /**
     * Shows up in template
     */
    '.assign-report-trigger': function($target, feed) {

        var patientId = $target.attr('data-patient-id')*1;
        var patientName =
            el8.apphome.reqAct.reqActPatients.getById(patientId).getDisplayName();
        feed.highlight(patientId).freeze();

        el8.appshared.dialog.reassignReviewUser.show({
            patientId: patientId,
            patientName: patientName,
            successCb: function() {
                // Remove the item from the feed
                feed.unfreeze();
                feed.remove(patientId, el8.util.consts.DEFAULT_DURATION);
            },
            cancelCb: function() {
                feed.unhighlight(patientId).unfreeze();
            }
        });
    }
};
